import { __extends } from "tslib";
/**
 * Created by Maksymilian Pryliński on 16-06-2019
 */
import BSSButtonComponent from '../../bss-button-component/js/bss-button-component.js';
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/compare-list.hbs';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
// import swiper controller to get swiper instance with modules through 'getSwiper' method
import BSSSwiperController from '../../bss-swiper-tabs-component/js/bss-swiper-controller';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSCompareListComponent class
 */
var templateObject = {
    defaultTemplate: template,
};
var BSSCompareListComponent = /** @class */ (function (_super) {
    __extends(BSSCompareListComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     * @listens {bss-start-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-resize-for-$ENTITY-INSTANCE-ID}
     */
    function BSSCompareListComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        _this._componentVersion = '@@name ver. @@version';
        logger.info('Component ' + _this._config.componentId + ' has been successful render');
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        /**
         * @desc this flag is responsible for initializing swiper // Swiper by www.idangero.us
         * @type {Boolean}
         * @private
         */
        _this._isInitOnSwiper = _this._config.initOnSwiper
            ? _this._config.initOnSwiper
            : false;
        /**
         * duration of radio tabs swiper animation
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._animDuration =
            typeof _this._config.animDuration === 'undefined' ||
                _this._config.animDuration === ''
                ? 300
                : parseInt(_this._config.animDuration);
        /**
         * @desc preconfiguration of swiper (with events and some important params) // Swiper by www.idangero.us
         * @type {Object}
         * @private
         */
        _this._swiperPreConfig = {
            animation: _this._animDuration,
            simulateTouch: true,
            slidesPerView: 'auto',
            slideClass: 'list-swiper-slide',
            wrapperClass: 'list-swiper-wrapper',
            grabCursor: true,
        };
        _this._isResizeEventOff = true;
        _this._swiper = null;
        if (typeof _this._config.remoteInit === 'undefined' ||
            _this._config.remoteInit === false) {
            _this._eventManager.subscribe('bss-entity-created-' + _this._config.entityInstanceId, _this._initSwiper.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        }
        _this._eventManager.subscribe('bss-component-data-rebound-' + _this._config.componentId, _this._destroySwiper.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._bindResize();
        _this._eventManager.subscribe('bss-start-resize-for-' + _this._config.entityInstanceId, _this._bindResize.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._eventManager.subscribe('bss-stop-resize-for-' + _this._config.entityInstanceId, _this._unbindResize.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._initButtonComponents();
        return _this;
    }
    /**
     * Overridden
     * BSSAbstractComponent _setConfig method override
     * @param {Object} config configuration
     * @private
     */
    BSSCompareListComponent.prototype.setConfig = function (config) {
        _super.prototype.setConfig.call(this, config);
        if (config.hasOwnProperty('resultData') && config.resultData) {
            this._prepareCompareListConfig();
        }
    };
    /**
     * @desc set component template
     * BSSAbstractComponent _setComponentTemplate method override
     * @public
     */
    BSSCompareListComponent.prototype.setTemplate = function () {
        logger.info('BSSCompareListComponent: ' +
            this._config.componentId +
            ' => function : setTemplate');
        // Set default container template
        _super.prototype.setTemplate.call(this);
        this._$componentContent = this._toolbox.$('#bss-compare-list_container-' + this._config.componentId);
        this._$componentContent
            .find('.bss-compare-list_btn')
            .off('click.' + this._config.componentId)
            .on('click.' + this._config.componentId, this._onClickEvent.bind(this));
    };
    /**
     * @desc prepares component for data binding
     * @private
     */
    BSSCompareListComponent.prototype._prepareCompareListConfig = function (resultData) {
        var _this = this;
        if (resultData === void 0) { resultData = this._config.resultData; }
        logger.info('BSSCompareListComponent: ' +
            this._config.componentId +
            ' => function : _prepareCompareListConfig');
        this._compareListResultData = resultData;
        for (var elemIndex in this._compareListResultData) {
            if (this._compareListResultData.hasOwnProperty(elemIndex)) {
                this._compareListResultData[elemIndex].id = elemIndex;
            }
        }
        var array = Object.keys(this._compareListResultData).map(function (key) { return _this._compareListResultData[key]; });
        this._config.compareListResultData = array.sort(this._sortByPosition);
    };
    /**
     * @desc generates 'learn more' button components
     * @private
     */
    BSSCompareListComponent.prototype._initButtonComponents = function () {
        var _this = this;
        logger.info('BSSCompareListComponent: ' +
            this._config.componentId +
            ' => function : _initButtonComponents');
        var _a = this._config, resultData = _a.resultData, componentId = _a.componentId;
        resultData.forEach(function (_a, productId) {
            var learnMoreLabel = _a.learnMoreLabel;
            try {
                var id = "".concat(componentId, "-").concat(productId);
                var btnComponentId = "".concat(id, "_learnMoreButton");
                var containerId = "".concat(id, "-learn-more_button");
                var defaultButtonConfig = {
                    componentId: btnComponentId,
                    componentType: 'ButtonComponent',
                    containerId: containerId,
                    productId: [productId, 'general'],
                    text: learnMoreLabel,
                    isPublicEvent: false,
                    sendEventToServer: false,
                    onClickEvent: "bss-learn-more-button-".concat(id, "-click"),
                    class: 'bss-button_btn--primary',
                };
                var buttonConfig = _this._config.buttonConfig
                    ? _this._toolbox._.merge(defaultButtonConfig, _this._config.buttonConfig)
                    : defaultButtonConfig;
                new BSSButtonComponent(_this._entityTemplate, "#".concat(containerId), buttonConfig, _this._eventManager, _this._formatter, _this._resolution, _this._toolbox);
            }
            catch (err) {
                console.log('BSSCompareListComponent: ' +
                    _this._config.componentId +
                    ' => function : "LEARN MORE" button initialization failed.');
            }
        });
    };
    /**
     * @desc publish event from disclaimer
     * @private
     */
    BSSCompareListComponent.prototype._onClickEvent = function (ev) {
        logger.info('BSSCompareListComponent: ' +
            this._config.componentId +
            ' => function : _onClickEvent | Params: ', ev);
        var button = this._toolbox.$(ev.currentTarget);
        var elemId = button.closest('.bss-compare-list_item').attr('data-id');
        // take from resultData as a source which is not sorted with _sortByPosition and does not cause logic errors when
        // product position is changed
        var disclaimer = this._config.resultData[elemId].disclaimer;
        var quoteId;
        var params;
        if (this._config.resultData[elemId].quoteId) {
            quoteId = this._config.resultData[elemId].quoteId;
        }
        if (this._config.onClickEvent) {
            if (quoteId) {
                params = { disclaimer: disclaimer, quoteId: quoteId };
            }
            else {
                params = { disclaimer: disclaimer };
            }
            this._eventManager.publish(this._config.onClickEvent, 'bss-compare-list', params, false);
        }
    };
    /**
     * @desc check if slider limits changed modifies updateObject(data) and fires super method
     * BSSAbstractComponent _setComponentTemplate method override
     * @param {String} publisherName - event owner name
     * @param {Object} data - updateObject holds new text and dataResult
     * @emits {bss-component-data-rebound-$COMPONENT-ID'}
     * @private
     */
    BSSCompareListComponent.prototype.update = function (publisherName, data) {
        logger.info('BSSCompareListComponent: ' +
            this._config.componentId +
            ' => function : _update' +
            ' | Params: ', publisherName, data);
        // save update timestap - for component-critical-error handling
        this._lastUpdateTimestamp = data.updateTimestamp;
        // if there is regular update event (not revert state) and critical error was thrown, do not update this component!
        if (this._stopUpdateFlag && !this._isRevertStateEvent) {
            this._stopUpdateFlag = false;
            if (typeof data.resultData[this._config.productId[0]].error_code !==
                'undefined') {
                this.setErrorObject({
                    errorMsg: 'config -> there is no complete set of data',
                    errorSeverity: 'critical',
                });
                this._onCriticalError(this._errorObj);
            }
            return;
        }
        this.preventUpdateEvent = true;
        if (this._config.productId[0] === 'general') {
            this.productIterator = this._config.productId.length - 1;
        }
        else {
            this.productIterator = 0;
        }
        this._resetErrorObject();
        this._prepareCompareListConfig(data.resultData);
        this.setTemplate();
        this._validateDataOnChange(data, true, true);
        if (this._tagEventOnThrow !== null) {
            this._throwTaggingEvent(this._tagEventOnThrow, true);
            this._tagEventOnThrow = null;
        }
        this.preventUpdateEvent = false;
        this._eventManager.publish('bss-component-data-rebound-' + this._config.componentId, this._config.componentType + '-' + this._config.componentId, data);
        this._isRevertStateEvent = false;
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSCompareListComponent.prototype._bindResize = function () {
        logger.info('BSSCompareListComponent ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            this._window.on('resize.' + this._config.componentId, this._initSwiper.bind(this));
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSCompareListComponent.prototype._unbindResize = function () {
        logger.info('BSSCompareListComponent ' +
            this._config.componentId +
            ' => function : _unbindResize');
        this._window.off('resize.' + this._config.componentId);
        this._isResizeEventOff = true;
    };
    BSSCompareListComponent.prototype._initSwiper = function () {
        logger.info('BSSCompareListComponent ' +
            this._config.componentId +
            ' => function : _initSwiper');
        if (this._resolution.getCurrent() === 'xs' && this._swiper === null) {
            if (this._isInitOnSwiper) {
                this._componentTemplate
                    .find('.bss-compare-list_item')
                    .addClass('list-swiper-slide');
                var swiperController = new BSSSwiperController({
                    selector: "#".concat(this._config.componentId, " .swiper-container"),
                    configuration: Object.assign({}, this._swiperPreConfig, this._config.listSwiperConfiguration),
                });
                this._swiper = swiperController.getSwiper();
            }
        }
        else if (this._resolution.getCurrent() !== 'xs' &&
            this._swiper !== null) {
            this._swiper.destroy(true, true);
            this._swiper = null;
        }
    };
    /**
     * @desc sort element
     * @private
     */
    BSSCompareListComponent.prototype._sortByPosition = function (a, b) {
        var aPosition = a.position;
        var bPosition = b.position;
        return aPosition < bPosition ? -1 : aPosition > bPosition ? 1 : 0;
    };
    /**
     * @desc destroy swiper
     * @private method
     */
    BSSCompareListComponent.prototype._destroySwiper = function () {
        logger.info('RadioTabsComponent: ' +
            this._config.componentId +
            ' => function : _destroySwiper');
        if (this._swiper !== null) {
            this._swiper.destroy(true, true);
            this._swiper = null;
        }
    };
    /**
     * @desc base destroy method
     */
    BSSCompareListComponent.prototype.destroy = function () {
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    return BSSCompareListComponent;
}(BSSAbstractComponent));
export default BSSCompareListComponent;
